<template>
    <ListeControl/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeControl from "@/components/GesCom/Control/ListeControl.vue";

    export default defineComponent({
      name: "ListeControlPage",
      components: {
        
        ListeControl,
      },
    });
  </script>